module.exports = __webpack_public_path__ + "img/IFEA-Treuhand-GmbH-LOGO-INLINE-blue-background.58d14b76.png";